import * as React from 'react';
import { Info } from '@smapiot/components';
import { login } from '../http';

export default () => {
  React.useEffect(login, []);

  return (
    <div className="shout text-center">
      <h2>302</h2>
      <h3>Redirecting ...</h3>
      <Info style={{ fontSize: '1.2em', marginTop: '3em' }}>You need to be authenticated for accessing this page.</Info>
    </div>
  );
};
